import React from "react";
import { useTranslation } from "react-i18next";
import Select from "../../../components/forms/Select/Select";

export default function ExamCenterFilters({
  regionFilter,
  setRegionFilter,
  isFullFilter,
  setIsFullFilter,
  regions,
}) {
  const [t] = useTranslation();

  const isFullOptions = [
    { label: t("admin.all"), value: null },
    { label: t("admin.yes"), value: true },
    { label: t("admin.no"), value: false },
  ];

  return (
    <div className="mb-4 flex gap-4">
      <div className="w-64">
        <Select
          label={t("admin.filter_region")}
          value={regionFilter}
          onChange={(opt) => setRegionFilter(opt?.value || null)}
          options={[{ label: t("admin.all"), value: null }, ...regions]}
          isSearchable
        />
      </div>
      <div className="w-64">
        <Select
          label={t("admin.filter_is_full")}
          value={isFullFilter}
          onChange={(opt) => setIsFullFilter(opt.value)}
          options={isFullOptions}
        />
      </div>
    </div>
  );
}
